/**
 * ServiceOptionChip — colour-coded badge for the appraisal's
 * service_option. Used in Pipeline / Stage worklist rows so the
 * office sees the workflow mix at a glance.
 *
 *   Reroof      → slate     (default/largest bucket)
 *   New Roof    → emerald   (greenfield install)
 *   Repairs     → orange    (defect-driven)
 *   Restoration → indigo    (paint + repair surface refresh)
 */
import React from 'react';

export const SERVICE_OPTION_THEMES = {
  'Reroof':       { bg: 'bg-slate-100',   text: 'text-slate-700',   ring: 'ring-slate-200',  dot: 'bg-slate-500'   },
  'New Roof':     { bg: 'bg-emerald-100', text: 'text-emerald-800', ring: 'ring-emerald-200',dot: 'bg-emerald-500' },
  'Repairs':      { bg: 'bg-orange-100',  text: 'text-orange-800',  ring: 'ring-orange-200', dot: 'bg-orange-500'  },
  'Restoration':  { bg: 'bg-indigo-100',  text: 'text-indigo-800',  ring: 'ring-indigo-200', dot: 'bg-indigo-500'  },
};

export const SERVICE_OPTIONS = ['Reroof', 'New Roof', 'Repairs', 'Restoration'];

export default function ServiceOptionChip({ value, size = 'sm' }) {
  const key = SERVICE_OPTION_THEMES[value] ? value : 'Reroof';
  const t = SERVICE_OPTION_THEMES[key];
  const cls = size === 'xs'
    ? 'text-[9px] px-1.5 py-0.5'
    : 'text-[10px] px-2 py-0.5';
  return (
    <span
      data-testid={`service-option-chip-${key.toLowerCase().replace(/\s+/g, '-')}`}
      className={`${cls} ${t.bg} ${t.text} ${t.ring} rounded-full ring-1 font-bold uppercase tracking-wide whitespace-nowrap inline-flex items-center gap-1`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${t.dot}`} />
      {key}
    </span>
  );
}
